 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

 const Icon = ({type}) => {
     const getIcon = () => {
         if (type === 'camera') {
             return 'fa-camera';
         } else if (type === 'bars') {
             return 'fa-bars';
         } else if (type === 'image') {
            return 'fa-image';
        }
     }
     return <FontAwesomeIcon icon={`fa-solid ${getIcon()}`}/>
 }

 export default Icon;